module.exports = __webpack_public_path__ + "static/media/icon-email.1e28376a.svg";